<template>
  <tw-list-group-item :class="[supportRequestMessage.user_id === loggedInUser.id? 'bg-blue-50':'bg-white','p-5']">
    <div class="float-right" size="sm">
      <tw-badge v-if="supportRequestMessage.user" variant="blue" class="font-bold">
        <icon icon="user" class="mr-1" /> {{ supportRequestMessage.user.name }}
      </tw-badge>
      <tw-badge variant="amber" class="mr-2">
        <icon icon="calendar" /> {{ $filters.formatDate(supportRequestMessage.created_at) }}
      </tw-badge>
      <tw-button v-if="supportRequestMessage.user_id === loggedInUser.id || loggedInUser.admin" :disabled="LoadingDeleting" class="float-right" variant="danger" size="xs" @click="deleteSupportRequestMessage">
        <tw-loading-spinner-mini v-if="LoadingDeleting">
          Deleting...
        </tw-loading-spinner-mini>
        <span v-else><icon icon="times" /> Delete reply </span>
      </tw-button>
    </div>

    <p v-html="supportRequestMessage.message" />
    <tw-uploaded-image v-for="upload in supportRequestMessage.uploads" :key="'uploadable-item-' + upload.id" root class="mr-1" :upload="upload" @deleted="deletedUploadable" />
  </tw-list-group-item>
</template>

<script>

import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwUploadedImage from '@/components/generic/uploads/tw-uploaded-image.vue'
import TwLoadingSpinnerMini from '@/components/generic/tw-loading-spinner-mini.vue'
import { useSupportRequestMessagesStore } from '@/stores/supportRequestMessages.js'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import TwBadge from '@/components/generic/tw-badge.vue'

export default {
  name: 'SupportRequestMessageListGroupItem',
  components: { TwBadge, TwLoadingSpinnerMini, TwUploadedImage, TwButton, TwListGroupItem },
  mixins: [loggedInUserMixin],
  props: {
    supportRequestMessage: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      LoadingDeleting: false
    }
  },
  methods: {
    async deleteSupportRequestMessage () {
      if (confirm('Are you sure you want to delete this message?')) {
        this.LoadingDeleting = true
        await useSupportRequestMessagesStore().itemDelete(this.supportRequestMessage.id)
        this.LoadingDeleting = false
      }
    },
    deletedUploadable () {
      // this.$store.dispatch('supportRequestMessages/supportRequestMessageById', this.supportRequestMessage.id)
    }
  }
}
</script>

<style scoped>

</style>
